import SelectInputField from './SelectInputField.component';

export default SelectInputField;
